import React, { Component } from 'react'
import { Layout, Breadcrumb } from 'antd'
import './SampleOrder.scss'
import { withRouter } from 'react-router-dom'
import OrderTableEdit from '../../components/OrderTableEdit/OrderTableEdit'
const { Content } = Layout

class SampleOrder extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div className="SampleOrderStyles">
        <Layout className="site-layout">
          <Content>
            <div className="layout_middel_content">
              <Breadcrumb>
                <Breadcrumb.Item>Sample Order</Breadcrumb.Item>
                <Breadcrumb.Item>List</Breadcrumb.Item>
              </Breadcrumb>
              <OrderTableEdit history={this.props.history} />
            </div>
          </Content>
        </Layout>
      </div>
    )
  }
}

export default withRouter(SampleOrder)
